import React, { Component } from 'react';
import { Glyphicon, FormGroup, FormControl, ControlLabel, Panel, Button, Modal, Image } from "react-bootstrap";
import UserProfile from './UserProfile';
import Input from './UI/Input/Input';
import PageSelection from './UI/PageSelection/PageSelection';
import "./ECards.css";
import AlertElement from './UI/Alert/Alert';
import ModalConfirmElement from './UI/ModalConfirm/ModalConfirm';
import ModalMessageElement from './UI/ModalMessage/ModalMessage';
import axios from 'axios';
import logoepay from '../ext/images/epay_row.png';
import Utility from './Utility';
import classes from './UI/Input/Input.css';
import pageSelection from './UI/PageSelection/PageSelection';

export class ECards extends Component {
    displayName = ECards.name

    constructor(props) {
        super(props);
        this.state = {
            forecasts: [],
            forecastsFiltered: [],
            loading: false,
            showerror: false,
            showmodal: false,
            classMessageTitle: 'alert-primary',
            showmodalform: false,
            modaltitle: '',
            modalbody: '',
            errorheader: '',
            errortext: '',
            formsconfig:
            {
                show: false,
                type: 0
            },
            orderType: 'dataPagamento',
            orderDirection: true,
            idTransazione: '',
            matricola: '',
            idRicariche: 0,
            qrcode: null,
            formIsValid: false,
            objform: {
                dateFrom: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'date',
                        placeholder: 'Da:'
                    },
                    value: Utility.todayDate(), //.nowAddDays(-1),
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                dateTo: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'date',
                        placeholder: 'A:'
                    },
                    value: Utility.todayDate(),
                    validation: {
                    required: false
                    },
                    valid: false,
                    touched: false
                },
                matricola: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'numeric',
                        placeholder: 'Matricola:'
                    },
                    value: '',
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                terminalId: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'numeric',
                        placeholder: 'TerminalID:'
                    },
                    value: '',
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                modello: {
                    elementType: 'select',
                    value: 'TUTTI',
                    elementConfig: {
                        placeholder: 'Device:',
                        options: [
                            { value: 'TUTTI', displayValue: 'TUTTI' },
                            { value: 'Ingenico_iUC160B', displayValue: 'iUC160B' },
                            { value: 'Ingenico_Duo', displayValue: 'iSelf Duo' },
                            { value: 'Pax_IM20', displayValue: 'PAX IM20' },
                            { value: 'Ingenico_iSelf2000', displayValue: 'iSelf 2000' },
                            { value: 'Ingenico_iSelf5000', displayValue: 'iSelf 5000' }
                        ]
                    },
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                ordinameto: {
                    elementType: 'select',
                    value: 0,
                    elementConfig: {
                        placeholder: 'Ordinamento:',
                        options: [
                            { value: 0, displayValue: 'Data' },
                            { value: 1, displayValue: 'Matricola' },
                            { value: 2, displayValue: 'Importo' },
                            { value: 3, displayValue: 'TerminalID' }
                        ]
                    },
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                verso_ordinameto: {
                    elementType: 'select',
                    value: 1,
                    elementConfig: {
                        placeholder: 'Verso Ord.:',
                        options: [
                            { value: 0, displayValue: 'Crescente' },
                            { value: 1, displayValue: 'Decrescente' }
                        ]
                    },
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                }
            },
            pageSelection: {
                value: 1,
                pageSize: 20,
                numPages: 1
            },
        };
        /*if (UserProfile.getLogin().level > 0) {
            const updatedForm = {
                ...this.state.objform
            };
            updatedForm['matricola'].elementType = 'hidden';
            this.setState({ objform: updatedForm });
        }*/
        //setInterval(() => {
        //    this.refresh();
        //}, 120000);
        //this.refresh();
        this.filterCustom = this.filterCustom.bind(this);
    }
    refresh() {
        this.setState({
            loading: true
        });
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            DateFrom: this.state.objform.dateFrom.value,
            DateTo: this.state.objform.dateTo.value,
            Device: this.state.objform.modello.value,
            Matricola: this.state.objform.matricola.value,
            PageIdentifier: this.state.pageSelection.value,
            Ordinamento: this.state.objform.ordinameto.value,
            VersoOrdinamento: this.state.objform.verso_ordinameto.value,
            terminalId: this.state.objform.terminalId.value,
        })
        axios.post('api/ECards/List', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState({
                    forecasts: respose.data.list,
                    pageSelection: respose.data.pageSelection,
                    loading: false
                });
            })
            .catch(data => {
            });
    }
    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }
    clickdismiss() {
        this.state.showerror = false;
        this.forceRender();
    }
    clickModalShow() {
        this.state.showmodal = true;
        this.forceRender();
    }
    clickModalCancel() {
        this.state.showmodal = false;
        this.forceRender();
    }
    filterCustom(value) {
        var result = true;
        //result &= (this.state.objform.matricola === '' || this.state.objform.matricola.lenght <= 2 || value.matricola.includes(this.state.objform.matricola.value));
        return result;
    }
    orderCustom(array) {
        var direction;
        if (this.state.orderDirection === true)
            direction = -1;
        else
            direction = 1;
        if (this.state.orderType === 'matricola') {
            return array.sort((a, b) => (a.matricola > b.matricola) ? direction : -direction)
        } else if (this.state.orderType === 'terminalid') {
            return array.sort((a, b) => (new Date(a.terminalid) > new Date(b.terminalid)) ? direction : -direction)
        } else if (this.state.orderType === 'data') {
            return array.sort((a, b) => (new Date(a.data) > new Date(b.data)) ? direction : -direction)
        }
    }
    orderFunction = (event, newtype) => {
        console.log('orderFunction', newtype);
        if (newtype === this.state.orderType) { this.state.orderDirection = !this.state.orderDirection }
        this.state.orderType = newtype;
        this.orderCustom(this.state.forecasts);
        this.forceRender();
    }
    forceRender = event => {
        this.setState({ time: Date.now() })
    }
    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.objform
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = true;
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        var pageSelectionNew = this.state.pageSelection
        pageSelectionNew.value = 1;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({ objform: updatedForm, formIsValid: formIsValid, pageSelection: pageSelectionNew }, () => {
            //this.refresh();
        });
    }
    pageSelectionPreviousHandler = (event) => {
        var pageSelectionTmp = this.state.pageSelection;

        if (pageSelectionTmp.value != 1)
            pageSelectionTmp.value = pageSelectionTmp.value - 1;

        this.setState({ pageSelection: pageSelectionTmp });

        this.refresh();
        this.forceRender();
    }
    pageSelectionNextHandler = (event) => {

        var pageSelectionTmp = this.state.pageSelection;
        if (pageSelectionTmp.value != pageSelectionTmp.numPages)
            pageSelectionTmp.value = pageSelectionTmp.value + 1;

        this.setState({ pageSelection: pageSelectionTmp });

        this.refresh();
        this.forceRender();
    }
    getTransactionDeteils = (event, obj) => {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            IdTransazione: obj.idTransazione,
        })
        axios.post('api/ECards/GetDeteils', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                console.log(respose);
                if (respose.data.esito == true) {
                    this.state.classMessageTitle = 'alert-info';
                } else {
                    this.state.classMessageTitle = 'alert-danger';
                }
                this.state.showmodal = true;
                this.state.modaltitle = "Dettagli messaggio";
                this.state.modalbody = respose.data.esitoMsg;
                this.forceRender();
            })
            .catch(data => {
                console.log('error:', data);
            });
    }
    clickModalOk() {
        this.state.showmodal = false;
        this.state.showerror = false;
        this.forceRender();
    }
    clickModalCancel() {
        this.state.showmodal = false;
        this.state.showmodalform = false;
        this.state.showerror = false;
        this.forceRender();
    }
    filterCustom(value) {
        var result = true;
        //result &= (this.state.objform.matricola === '' || value.matricola.includes(this.state.objform.matricola.value));
        return result;
    }

    ricerca = (event) => {
        this.refresh();
        this.forceRender();
    }
    static renderTable(forecasts, administrator, filterCustom, orderDirection, orderFunction, getTransactionDeteils) {
        return (

            <table className='table' >
                <thead>
                    <tr>
                        {(administrator) && <th>Matricola</th>}
                        <th>TerminalID</th>
                        <th>Modello</th>
                        <th>Importo</th>
                        {(administrator) && <th>Esito</th>}
                        <th>Data</th>
                        <th>Dettagli</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        forecasts.filter(filterCustom)
                            .map(forecast =>
                                <tr key={forecast.idTransazione}>
                                    {(administrator) && <td>{forecast.matricola}</td>}
                                    <td>{forecast.terminalId}</td>
                                    <td>{forecast.device}</td>
                                    <td>{(Math.round(forecast.importo * 100) / 100).toFixed(2)} EUR</td>
                                    {(administrator && forecast.esito == 1) && <td>SUCCESSO</td>}
                                    {(administrator && forecast.esito == 0) && <td>ERRORE</td>}
                                    <td>{forecast.data}</td>
                                    {(forecast.esito == 1) && <td><Button onClick={(event) => getTransactionDeteils(event, forecast)} type="button" className="btn btn-info">Dettagli</Button></td>}
                                    {(forecast.esito == 0) && <td><Button onClick={(event) => getTransactionDeteils(event, forecast)} type="button" className="btn btn-danger">Dettagli</Button></td>}
                                </tr>
                            )}
                </tbody>
            </table>
        );
    }
    render() {
        const formElementsArray = [];
        for (let key in this.state.objform) {
            formElementsArray.push({
                id: key,
                config: this.state.objform[key]
            });
        }
        let formInser = (
            <div>
                <div className="row">
                    {formElementsArray.map(formElement => (
                        <div className="col-sm-2" key={'div' + formElement.id}>
                            <Input
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={formElement.config.value}
                                invalid={!formElement.config.valid}
                                shouldValidate={formElement.config.validation}
                                touched={formElement.config.touched}
                                changed={(event) => this.inputChangedHandler(event, formElement.id)}
                                textdisabled={false} />
                        </div>
                    ))}
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <PageSelection
                            value={this.state.pageSelection.value}
                            numPages={this.state.pageSelection.numPages}
                            previous={(event) => this.pageSelectionPreviousHandler(event)}
                            next={(event) => this.pageSelectionNextHandler(event)}
                        />
                    </div>
                </div>
                <div className="col-sm-10">
                    <button onClick={(event) => this.ricerca(event)} type="button" className="btn btn-info">RICERCA</button>
                </div>
            </div>
        );
        let contents = this.state.loading
            ? <p className="col-sm-10"><em>Loading...</em></p>
            : ECards.renderTable(this.state.forecasts, (UserProfile.getLogin().level === -99), this.filterCustom, this.state.orderDirection, this.orderFunction, this.getTransactionDeteils);

        return (
            <div>
                {(this.state.showerror == true) && <AlertElement strong={this.state.errorheader} message={this.state.errortext} clicked={(event) => this.clickdismiss(event)} />}
                <div className="row">
                    <div className="col-sm-10">
                        <h1 className="left">Pagamenti con Carte</h1>
                    </div>
                </div>
                <span></span>
                {formInser}
                <ModalConfirmElement showmodal={this.state.showmodal} matricola={this.state.matricola} clickedConfirm={(event) => this.clickModalConfirm(event)} clickedCancel={(event) => this.clickModalCancel(event)}/>
                {contents}
                <ModalMessageElement
                    classTitle={this.state.classMessageTitle}
                    showmodal={this.state.showmodal}
                    title={this.state.modaltitle}
                    isqrcode={false}
                    body={this.state.modalbody}
                    clickedOk={(event) => this.clickModalOk(event)}
                    clickedCancel={(event) => this.clickModalCancel(event)} />
            </div >
        );
    }
}
